export default __webpack_public_path__ + "static/media/rank_one.357c56a3.svg";